import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-store-navigation',
  templateUrl: './store-navigation.component.html',
  styleUrl: './store-navigation.component.scss'
})
export class StoreNavigationComponent {

  modalData: any;
  constructor(
    public dialogRef: MatDialogRef<StoreNavigationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.modalData = data;
  }

  ngOnInit(){

  }

  close(){
    this.dialogRef.close();
  }

  navigateToStore() {
    //screen.orientation.lock('landscape');
    if (navigator.userAgent.match(/Android/i) && window.innerWidth < 450) {
      window.open("https://play.google.com/store/apps/details?id=com.capital.cbt", "_self")
    } else if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
      window.open("https://apps.apple.com/jo/app/capital-bank-mobile-jordan/id1630681705", "_self")
    }

  }

  googleStoreNavigation(){

  }

  appleStoreNavigation(){
    
  }
}
